import { Component, OnInit, Input, Output } from '@angular/core';
import { ProcessesService } from '../services/processes.service';
import { Process } from '../models/process';
import { Observable } from 'rxjs';
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';
import { Router } from "@angular/router";

@Component({
  selector: 'app-edit-process',
  templateUrl: './edit-process.component.html',
  styleUrls: ['./edit-process.component.css']
})
export class EditProcessComponent implements OnInit{

  processForm: FormGroup
  title: string
  @Input()
  process: Process
  

  constructor(private formBuilder: FormBuilder, private _processesService: ProcessesService, private router: Router) { }

  ngOnInit()
  {
  	this.processForm = this.formBuilder.group({  	
      status:[],
      description: [],
      narrative:[],
      active_yn:[],
      sequence:[],
      user_reference_a:[],
      user_reference_b:[],
      user_reference_c:[]
    });
    console.log(this.process);
    if (!this.process) {
      this.title = "Add a process"
      this.process = new Process();
    }
    else{
      this.title = "Edit a process"
      this.processForm.get('description').setValue(this.process.description);
      this.processForm.get('status').setValue(this.process.status);
      this.processForm.get('narrative').setValue(this.process.narrative);
      this.processForm.get('user_reference_a').setValue(this.process.user_reference_a);
      this.processForm.get('user_reference_b').setValue(this.process.user_reference_b);
      this.processForm.get('user_reference_b').setValue(this.process.user_reference_c);
      this.processForm.get('active_yn').setValue(this.process.active_yn);
      this.processForm.get('sequence').setValue(this.process.sequence);
    }
  }

  back(){
    window.location.href = '/processes';
  }
  
  onSubmit(){
    var process = this.processForm.value;
    
    if(this.process.record_id !== 0){
      process.record_id = this.process.record_id;
      this._processesService.editProcess(process).subscribe((data) => {
        console.log('as');
        window.location.href = '/processes';
        
      }, error => console.error(error));
    }
    else{
      this._processesService.saveProcess(process).subscribe((data) => {
        this.router.navigate(['/processes']);
      }, error => console.error(error));
    }
  }


}
